export default __webpack_public_path__ + "fonts/9b7b5fc6426ea435013f76b247a53b18.eot";